'use client';

import { useFieldContext } from '@/lib/form';
import { Checkbox } from '@sapling/ui/components/ui/checkbox';
import { Label } from '@sapling/ui/components/ui/label';
import { FieldError, fieldErrorId } from './field-error';

export function CheckboxField({
  label,
  description,
}: {
  label: string;
  description?: React.ReactNode;
}) {
  const field = useFieldContext<boolean>();
  const hasErrors =
    field.state.meta.isTouched && field.state.meta.errors.length > 0;

  return (
    <div className="flex flex-row items-start space-x-3 rounded-md border p-4 shadow-sm">
      <Checkbox
        id={field.name}
        checked={field.state.value}
        onCheckedChange={(checked) => field.handleChange(checked === true)}
        onBlur={field.handleBlur}
        aria-invalid={hasErrors}
        aria-describedby={hasErrors ? fieldErrorId(field.name) : undefined}
      />
      <div className="space-y-1 leading-none">
        <Label htmlFor={field.name} className="font-normal">
          {label}
        </Label>
        {description && (
          <p className="text-xs text-neutral-500">{description}</p>
        )}
        <FieldError errors={field.state.meta.errors} fieldName={field.name} />
      </div>
    </div>
  );
}
